import { render, staticRenderFns } from "./wanduwanglink.vue?vue&type=template&id=1ce633a8&scoped=true"
import script from "./wanduwanglink.vue?vue&type=script&lang=js"
export * from "./wanduwanglink.vue?vue&type=script&lang=js"
import style0 from "./wanduwanglink.vue?vue&type=style&index=0&id=1ce633a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce633a8",
  null
  
)

export default component.exports